<template>
  <div class="dash-root">
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#3ea56e"
      size="128"
      is-full-screen
    />
    
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>

    <v-snackbar v-model="showsnackbar" color="#3ea56e" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <div v-if="!ServerError">
      <!-- Page Header -->
      <div class="dash-page-header">
        <div>
          <p class="dash-page-header__eyebrow">Overview</p>
          <h1 class="dash-page-header__title">User Reviews</h1>
        </div>
        <div class="dash-page-header__actions">
          <!-- <div class="search-bar-container">
            <v-icon size="18" color="#94a3b8">mdi-magnify</v-icon>
            <input 
              v-model="search" 
              type="text" 
              class="search-input" 
              placeholder="Search reviews..."
            />
          </div> -->
        </div>
      </div>

      <!-- Review List -->
      <div class="review-list" v-if="user && user.length > 0">
        <div class="review-card" v-for="(item, i) in user" :key="item._id || i">
          <!-- User Info Section -->
          <div class="review-card__user-section" v-if="item.user">
            <v-avatar size="64" class="review-card__avatar">
              <img :src="mediaUURL + item.user.image" alt="User" v-if="item.user.image">
              <v-icon v-else size="32" color="#a0aec0">mdi-account</v-icon>
            </v-avatar>
            <div class="review-card__user-info">
              <h3 class="review-card__name">{{ item.user.firstname }} {{ item.user.lastname }}</h3>
              <div class="review-card__contact">
                <span class="review-card__contact-item" v-if="item.user.email">
                  <v-icon size="14" color="#8a93a4" class="mr-1">mdi-email-outline</v-icon>
                  {{ item.user.email }}
                </span>
                <span class="review-card__contact-item" v-if="item.user.phone">
                  <v-icon size="14" color="#8a93a4" class="mr-1">mdi-phone-outline</v-icon>
                  {{ item.user.phone }}
                </span>
              </div>
            </div>
          </div>
          <div class="review-card__user-section" v-else>
             <v-avatar size="64" class="review-card__avatar">
               <v-icon size="32" color="#a0aec0">mdi-account</v-icon>
             </v-avatar>
             <div class="review-card__user-info">
               <h3 class="review-card__name">Unknown User</h3>
             </div>
          </div>

          <!-- Divider for mobile/desktop -->
          <div class="review-card__divider"></div>

          <!-- Review Content Section -->
          <div class="review-card__content-section">
            <div class="review-card__product">
              <span class="review-card__label">Product</span>
              <span class="review-card__value">{{ item.product ? item.product.productname : 'N/A' }}</span>
            </div>
            
            <div class="review-card__rating">
              <span class="review-card__label">Rating</span>
              <div class="review-card__stars">
                <v-icon size="16" color="#f59e0b" v-for="n in 5" :key="n">
                  {{ item.rating >= n ? 'mdi-star' : 'mdi-star-outline' }}
                </v-icon>
                <span class="review-card__rating-text ml-1">{{ item.rating }}</span>
              </div>
            </div>

            <div class="review-card__comment">
              <span class="review-card__label">Comment</span>
              <p class="review-card__comment-text">{{ item.comment || 'No comment provided.' }}</p>
            </div>
          </div>

          <!-- Actions Section -->
          <div class="review-card__actions-section">
            <v-dialog v-model="item.delete" max-width="400px" content-class="modern-dialog">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon color="#ff4757" v-on="on" v-bind="attrs" class="action-btn-delete">
                  <v-icon size="22">mdi-delete-outline</v-icon>
                </v-btn>
              </template>
              <v-card class="dialog-card">
                <div class="dialog-icon">
                  <v-icon color="#ff4757" size="32">mdi-alert-circle-outline</v-icon>
                </div>
                <h3 class="dialog-title">Delete Review?</h3>
                <p class="dialog-subtitle">Are you sure you want to delete this review? This action cannot be undone.</p>
                <div class="dialog-actions">
                  <v-btn class="btn-cancel" @click="item.delete = false" depressed>Cancel</v-btn>
                  <v-btn class="btn-confirm" @click="deleteItem(item)" depressed>Delete</v-btn>
                </div>
              </v-card>
            </v-dialog>
          </div>
        </div>

        <!-- Pagination -->
        <div class="pagination-wrapper" v-if="pages > 1">
          <v-pagination
            :length="pages"
            :total-visible="7"
            v-model="currentPage"
            color="#3ea56e"
          ></v-pagination>
        </div>
      </div>

      <!-- Empty State -->
      <div class="empty-state" v-else-if="!appLoading">
        <div class="empty-state__icon">
          <v-icon size="48" color="#a0aec0">mdi-comment-off-outline</v-icon>
        </div>
        <h3 class="empty-state__title">No Reviews Found</h3>
        <p class="empty-state__subtitle">We couldn't find any user reviews matching your criteria.</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      expanded: [],
      singleExpand: true,
      appLoading: false,
      dialogDelete: false,
      ServerError: false,
      showsnackbar: false,
      msg: null,
      search: "",
      currentPage: 1,
      pages: 0,
      totalData: 0,
      count: 10,
      totalRows: 0,
      user: [],
    };
  },
  mounted() {
    this.getData();
  },
  watch: {
    currentPage() {
      this.getData();
    },
    search() {
      this.getData();
    },
  },
  methods: {
    deleteItem(r) {
      axios({
        url: "/review/delete",
        method: "GET",
        params: {
          id: r._id,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.delete = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/review/all",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          count: this.count,
          page: this.currentPage,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.user = response.data.data;
          this.pages = response.data.pages;
          this.totalData = response.data.count;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    userinfo(uid) {
      this.$router.push({ name: "userReviewDetails", params: { userid: uid } });
    },
    edit(uid) {
      this.$router.push({ name: "edit", params: { userid: uid } });
    },
  },
};
</script>

<style scoped>
.dash-root {
  font-family: poppinsmedium, Roboto, sans-serif;
  padding: 12px 12px;
}

/* Page Header */
.dash-page-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
}

.dash-page-header__eyebrow {
  font-size: 13px;
  color: #8a93a4;
  margin: 0 0 4px;
  font-family: poppinsmedium, sans-serif;
}

.dash-page-header__title {
  font-size: 22px;
  font-weight: 700;
  color: #1a202c;
  margin: 0;
  font-family: poppinsbold, sans-serif;
  line-height: 1.2;
}

/* Search Bar */
.search-bar-container {
  display: flex;
  align-items: center;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0 12px;
  height: 42px;
  width: 280px;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(0,0,0,0.02);
}

.search-bar-container:focus-within {
  border-color: #3ea56e;
  box-shadow: 0 0 0 3px rgba(62, 165, 110, 0.1);
}

.search-input {
  border: none;
  background: transparent;
  outline: none;
  font-family: poppinsmedium, sans-serif;
  font-size: 13px;
  color: #334155;
  width: 100%;
  margin-left: 8px;
}

.search-input::placeholder {
  color: #94a3b8;
}

/* Review List */
.review-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.review-card {
  background: #ffffff;
  border: 1px solid #eaedf0;
  border-radius: 16px;
  padding: 20px;
  display: flex;
  align-items: stretch;
  gap: 24px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  text-align: left;
}

.review-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.06);
  border-color: #d1d5db;
}

@media (max-width: 960px) {
  .review-card {
    flex-direction: column;
    gap: 16px;
  }
}

.review-card__user-section {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 260px;
  min-width: 260px;
  flex-shrink: 0;
}

.review-card__avatar {
  border: 2px solid #f1f5f9;
  background: #f8fafc;
}

.review-card__user-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow: hidden;
}

.review-card__name {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  font-family: poppinssemibold, sans-serif;
}

.review-card__contact {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.review-card__contact-item {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #64748b;
  word-break: break-all;
}

.review-card__divider {
  width: 1px;
  background: #eaedf0;
  margin: 0;
}

@media (max-width: 960px) {
  .review-card__divider {
    width: 100%;
    height: 1px;
  }
}

.review-card__content-section {
  flex: 1;
  display: grid;
  grid-template-columns: 2fr 130px 1.5fr;
  gap: 24px;
}

@media (max-width: 768px) {
  .review-card__content-section {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

.review-card__product,
.review-card__comment {
  min-width: 0;
  word-break: break-word;
}

.review-card__label {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #94a3b8;
  font-family: poppinssemibold, sans-serif;
  display: block;
  margin-bottom: 6px;
}

.review-card__value {
  font-size: 14px;
  color: #334155;
  font-family: poppinsmedium, sans-serif;
}

.review-card__stars {
  display: flex;
  align-items: center;
}

.review-card__rating-text {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
}

.review-card__comment-text {
  font-size: 14px;
  color: #475569;
  line-height: 1.5;
  margin: 0;
}

.review-card__actions-section {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 16px;
}

@media (max-width: 960px) {
  .review-card__actions-section {
    justify-content: flex-end;
    padding-left: 0;
    margin-top: -8px;
  }
}

.action-btn-delete {
  background: #fff5f5 !important;
  border: 1px solid #ffe4e6 !important;
  border-radius: 10px;
  transition: all 0.2s ease;
}

.action-btn-delete:hover {
  background: #ffe4e6 !important;
  border-color: #fda4af !important;
  transform: scale(1.05);
}

/* Pagination */
.pagination-wrapper {
  margin-top: 24px;
  display: flex;
  justify-content: center;
}

/* Empty State */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  background: #ffffff;
  border: 1px dashed #cbd5e1;
  border-radius: 16px;
  text-align: center;
  margin-top: 20px;
}

.empty-state__icon {
  width: 80px;
  height: 80px;
  background: #f8fafc;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.empty-state__title {
  font-size: 18px;
  font-weight: 600;
  color: #1a202c;
  margin: 0 0 8px;
  font-family: poppinssemibold, sans-serif;
}

.empty-state__subtitle {
  font-size: 14px;
  color: #8a93a4;
  margin: 0;
}

/* Dialog Styles */
::v-deep .modern-dialog {
  border-radius: 16px;
}

.dialog-card {
  padding: 24px;
  text-align: center;
  border-radius: 16px;
}

.dialog-icon {
  width: 56px;
  height: 56px;
  background: #fff5f5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
}

.dialog-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a202c;
  margin: 0 0 8px;
  font-family: poppinssemibold, sans-serif;
}

.dialog-subtitle {
  font-size: 13px;
  color: #8a93a4;
  margin: 0 0 24px;
}

.dialog-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.btn-cancel {
  flex: 1;
  background: #f1f5f9 !important;
  color: #475569 !important;
  border-radius: 8px;
  text-transform: none;
  font-weight: 600;
  box-shadow: none !important;
}

.btn-confirm {
  flex: 1;
  background: #ff4757 !important;
  color: #ffffff !important;
  border-radius: 8px;
  text-transform: none;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(255, 71, 87, 0.2) !important;
}
</style>
